import React from "react";

import { ICandidate } from "../../types";
import useI18n from "@I18n/hooks/useI18n";

import { Icon } from "@UI/Components/Icon/Icon";
import { HStack, VStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { LocationDot } from "@UI/Components/Icons/LocationDot";
import { SolidCircleCheck } from "@UI/Components/Icons/CircleCheck";

import messages from "../messages";
import { useServiceRequestFlow } from "@modules/ServiceRequest/hooks/useServiceRequestFlow";

const CandidateInfoItem = (props: {
  icon: React.FC<JSX.IntrinsicAttributes>;
  text: string;
  iconColor: string;
}) => {
  const { icon, text, iconColor } = props;
  return (
    <HStack
      width="inherit"
      background="gray.100"
      borderRadius="10px"
      py={{ base: "6px", lg: "8px" }}
      px={{ base: "8px", lg: "12px" }}
      textAlign="start"
    >
      <Icon as={icon} color={iconColor} width="16px" height="16px" />
      <Text
        as="h5"
        fontWeight="400"
        fontSize={{ base: "0.875rem", md: "1rem" }}
        m={0}
      >
        {text}
      </Text>
    </HStack>
  );
};

export const CandidateProximityAndJobDoneCountSection = (props: ICandidate) => {
  const { formatMessage } = useI18n();
  const { serviceRequest } = useServiceRequestFlow();

  const distance = (props?.distance).toFixed(1) + " km";

  return (
    <VStack width="full" alignItems="start" spacing="4px">
      <CandidateInfoItem
        icon={LocationDot}
        iconColor="pink"
        text={formatMessage(messages["serviceRequest.distance"], {
          distance,
        })}
      />

      {props?.similarRequestCount > 0 &&
        messages[`s_cat.${serviceRequest.sCategory}`] && (
          <CandidateInfoItem
            icon={SolidCircleCheck}
            iconColor="green.500"
            text={`${formatMessage(messages["s_cat.similarRequestCount"], {
              count: props?.similarRequestCount,
              isPlural: props?.similarRequestCount > 1 ? "s" : "",
            })} ${formatMessage(
              messages[`s_cat.${serviceRequest.sCategory}`]
            )}`}
          />
        )}
    </VStack>
  );
};
